module.exports = __webpack_public_path__ + "img/cun_new_logo_copy1.04f4b776.png";